module.exports = __webpack_public_path__ + "img/耗材采购.6a8cbc35.png";